// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import LocalSeoConsultantPeterboroughPage from "../pages/LocalSeoConsultantPeterborough/LocalSeoConsultantPeterborough";
const __wvcRoutePaths = ["/LocalSeoConsultantPeterboroughPage", "/local-seo-consultant-peterborough"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["404", "about-me", "aboutmepage", "affordable-seo-services-uk", "affordableseoservicesukpage", "ai-search-optimisation", "aisearchoptimisationpage", "b2b-professional-services", "b2b-seo-lead-generation", "b2bprofessionalservicespage", "b2bseoleadgenerationpage", "blog", "blogpage", "case-studies", "casestudiespage", "commercial-cleaning-case-study", "commercialcleaningcasestudypage", "contact", "contactpage", "dermatology-practice-case-study", "dermatologypracticecasestudypage", "diy-seo-software", "diyseosoftwarepage", "ecommerce-retail", "ecommerce-seo", "ecommerceretailpage", "ecommerceseopage", "fashion-retailer-case-study", "fashionretailercasestudypage", "fractional-seo-consultant", "fractionalseoconsultantpage", "freelance-seo-consultant", "freelanceseoconsultantpage", "hire-seo-consultant", "hireseoconsultantpage", "home", "homepage", "international-locations", "international-seo", "internationallocationspage", "internationalseopage", "local-consumer-services", "local-seo", "local-seo-consultant-bedford", "local-seo-consultant-belfast", "local-seo-consultant-bolton", "local-seo-consultant-carlisle", "local-seo-consultant-chelmsford", "local-seo-consultant-cheltenham", "local-seo-consultant-colchester", "local-seo-consultant-derby", "local-seo-consultant-doncaster", "local-seo-consultant-dundee", "local-seo-consultant-gloucester", "local-seo-consultant-hull", "local-seo-consultant-ipswich", "local-seo-consultant-lincoln", "local-seo-consultant-luton", "local-seo-consultant-milton-keynes", "local-seo-consultant-northampton", "local-seo-consultant-norwich", "local-seo-consultant-peterborough", "local-seo-consultant-plymouth", "local-seo-consultant-preston", "local-seo-consultant-stoke-on-trent", "local-seo-consultant-sunderland", "local-seo-consultant-swansea", "local-seo-consultant-telford", "local-seo-consultant-wakefield", "local-seo-consultant-warrington", "local-seo-consultant-wigan", "local-seo-consultant-wolverhampton", "local-seo-consultant-york", "localandconsumerservicespage", "localseoconsultantbedfordpage", "localseoconsultantbelfastpage", "localseoconsultantboltonpage", "localseoconsultantcarlislepage", "localseoconsultantchelmsfordpage", "localseoconsultantcheltenhampage", "localseoconsultantcolchesterpage", "localseoconsultantderbypage", "localseoconsultantdoncasterpage", "localseoconsultantdundeepage", "localseoconsultantgloucesterpage", "localseoconsultanthullpage", "localseoconsultantipswichpage", "localseoconsultantlincolnpage", "localseoconsultantlutonpage", "localseoconsultantmiltonkeynespage", "localseoconsultantnorthamptonpage", "localseoconsultantnorwichpage", "localseoconsultantpeterboroughpage", "localseoconsultantplymouthpage", "localseoconsultantprestonpage", "localseoconsultantstokeontrentpage", "localseoconsultantsunderlandpage", "localseoconsultantswanseapage", "localseoconsultanttelfordpage", "localseoconsultantwakefieldpage", "localseoconsultantwarringtonpage", "localseoconsultantwiganpage", "localseoconsultantwolverhamptonpage", "localseoconsultantyorkpage", "localseopage", "monthly-seo-services", "monthlyseoservicespage", "national-seo", "nationalseopage", "post", "privacy-policy", "privacypolicypage", "regulated-specialist-industries", "regulatedandspecialistindustriespage", "resin-flooring-seo-for-coventry-companies", "resinflooringseocoventrycompaniespage", "search", "seo-agency-alternative-uk", "seo-audits", "seo-consultant-uk", "seo-for-access-control-companies-leeds", "seo-for-commercial-hvac-companies-newcastle", "seo-freelancer-dubai", "seoagencyalternativeukpage", "seoauditspage", "seoconsultantukpage", "seoforaccesscontrolcompaniesleedspage", "seoforcommercialhvaccompaniesnewcastlepage", "seofreelancerdubaipage", "services", "servicespage", "starting-local-to-go-global-case-study", "startinglocaltogoglobalcasestudypage", "technical-seo", "technicalseopage", "technology-saas", "technologyandsaaspage", "terms-of-service", "termsofservicepage", "uk-cities-areas", "ukcitiesareaspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<LocalSeoConsultantPeterboroughPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<LocalSeoConsultantPeterboroughPage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
